enum FormVariant {
  ENROLLMENT,
  EDIT,
}

export default FormVariant;
